import { configureStore } from '@reduxjs/toolkit';
import shopReducer from './shopReducer';

export default configureStore({
  reducer: {
    shop: shopReducer,
  }
});
